var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "41px",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#F5F5F5",
    cx: 32,
    cy: 33,
    rx: 32,
    ry: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 0.000000)",
    stroke: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46,12.76 L35.854,1.258 C35.367,0.474 34.656,0 33.907,0 L12.093,0 C11.344,0 10.633,0.474 10.146,1.257 L0,12.761 L0,22 L46,22 L46,12.76 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.613,15.931 C32.613,14.326 33.607,13.001 34.84,13 L46,13 L46,31.137 C46,33.26 44.68,35 43.05,35 L2.95,35 C1.32,35 0,33.259 0,31.137 L0,13 L11.16,13 C12.393,13 13.387,14.323 13.387,15.928 L13.387,15.95 C13.387,17.555 14.392,18.851 15.624,18.851 L30.376,18.851 C31.608,18.851 32.613,17.543 32.613,15.938 L32.613,15.931 Z",
    id: "Path",
    fill: "#FAFAFA"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.52a8f92311d85c782036d6bc0e993792.svg";
export { ForwardRef as ReactComponent };